/* eslint-disable consistent-return */
'use client'

import { RefObject, useEffect } from 'react'

const showOverlaySpinner = () => {
  if (window.document.getElementById('hardlink-loader')) {
    return
  }

  const loader = window.document.createElement('div')
  loader.id = 'hardlink-loader'
  loader.className = 'hardlink-loader'

  const spinner = window.document.createElement('div')
  spinner.className = 'hardlink-spinner'

  loader.appendChild(spinner)
  window.document.body.appendChild(loader)
}

export function useHardNavigation(
  ref: RefObject<HTMLAnchorElement>,
  href: string
) {
  useEffect(() => {
    if (!href) {
      return
    }
    const el = ref.current
    if (!el) {
      return
    }

    const handleClick = (event: MouseEvent) => {
      event.preventDefault()

      const navigate = () => {
        window.location.href = href
      }

      if ('startViewTransition' in window.document) {
        el.setAttribute('data-hardlink', 'view-transition')
        window.document?.startViewTransition?.(navigate)
      } else {
        el.setAttribute('data-hardlink', 'fallback')
        showOverlaySpinner()
        setTimeout(navigate, 300)
      }
    }

    el.setAttribute('data-hardlink', 'none')
    el.addEventListener('click', handleClick)

    return () => {
      el.removeEventListener('click', handleClick)
    }
  }, [ref, href])
}
